// extracted by mini-css-extract-plugin
export default {"LoaderContainer":"TNLoader_LoaderContainer__yH2nQ"};